module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/~/axios/index.js
// module id = IbaR
// module chunks = 0